import { render, staticRenderFns } from "./InAppMenu.vue?vue&type=template&id=3773d3b0&"
import script from "./InAppMenu.vue?vue&type=script&lang=js&"
export * from "./InAppMenu.vue?vue&type=script&lang=js&"
import style0 from "./InAppMenu.vue?vue&type=style&index=0&id=3773d3b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports